angular.module('impactx.search').directive('ixSearchToolbar', function () {
    return {
        restrict: 'E',
        templateUrl: 'modules/search/templates/search.toolbar.html',
        controller: 'SearchToolBarCtrl',
        controllerAs: 'seachToolBarCtrl',
        scope: {
            hideBackLink: '@hideBackLink'
        }
    }
});